if(!customElements.get('read-more')) {
  class ComponentReadMore extends HTMLElement {
    constructor() {
      super();
      this.moreButton = this.querySelector('.read-more');
      this.lessButton = this.querySelector('.read-less');
      this.moreContent = this.querySelector('.more-content');
      this.truncContent = this.querySelector('.trunced');
      if(this.dataset.sectionId){
        this.parentSection = document.querySelector('#shopify-section-'+this.dataset.sectionId);
        if(this.parentSection){
          this.utilTabElement = this.parentSection.querySelector('util-tabs');
        }
      }
      this.moreButton.addEventListener('click', ()=> {
        this.moreContent.classList.remove('hide');
        this.truncContent.classList.add('hide');
        this.checktabs();
      });

      this.lessButton.addEventListener('click', ()=> {
        this.moreContent.classList.add('hide');
        this.truncContent.classList.remove('hide');
        this.checktabs();
      });

    }

    checktabs(){
      if(this.utilTabElement){
        this.utilTabElement.matchHeight();
      }
    }
   

  }
  customElements.define('read-more', ComponentReadMore);
}